import { DemoStatusFilter, Industry } from '../../../extViewmodels';

// Filter option types
export type FilterOption<T = string> = { label: string; value: T };

// Only show non-Past Demos options in the dropdown (Past Demos is handled by the tab)
export const DEMO_STATUS_OPTIONS = [
	{ label: 'Demos to Confirm', value: DemoStatusFilter.DemosToConfirm },
	{ label: 'Demos to Reschedule', value: DemoStatusFilter.DemosToReschedule },
	{ label: 'Upcoming Demos', value: DemoStatusFilter.UpcomingDemos },
];

// Past Demos tab filter options (sorted alphabetically)
export const DEAL_STAGE_OPTIONS: FilterOption[] = [
	{ label: 'Appointment No Show', value: 'Appointment No Show' },
	{ label: 'Appointment Rescheduled', value: 'Appointment Rescheduled' },
	{ label: 'Appointment scheduled', value: 'Appointment scheduled' },
	{ label: 'Best Case', value: 'Best Case' },
	{ label: 'Closed lost', value: 'Closed lost' },
	{ label: 'Closed won', value: 'Closed won' },
	{ label: 'Commit', value: 'Commit' },
	{ label: 'Scheduled Pipeline', value: 'Scheduled Pipeline' },
	{ label: 'Unscheduled Pipeline', value: 'Unscheduled Pipeline' },
];

export const LEAD_SOURCE_OPTIONS: FilterOption[] = [
	{ label: 'Inbound', value: 'Levitate Inbound' },
	{ label: 'Outbound', value: 'Outbound' },
	{ label: 'Upgrade', value: 'Upgrade' },
];

export const ADD_ON_OPTIONS: FilterOption[] = [
	{ label: 'Custom Content Calendar', value: 'Custom Content Calendar' },
	{ label: 'Facebook Ads', value: 'Facebook Ads' },
	{ label: 'Google Local Service Ads', value: 'Google Local Service Ads' },
	{ label: 'Lennox', value: 'Lennox' },
	{ label: 'None', value: 'None' },
];

export const INBOUND_CHANNEL_OPTIONS: FilterOption[] = [
	{ label: '3rd Party Reviews', value: '3rd Party Reviews' },
	{ label: 'Association', value: 'Association' },
	{ label: 'Blitz', value: 'Blitz' },
	{ label: 'Broker Dealer', value: 'Broker Dealer' },
	{ label: 'Conference', value: 'Conference' },
	{ label: 'Direct Mail', value: 'Direct Mail' },
	{ label: 'Email', value: 'Email' },
	{ label: 'Facebook', value: 'Facebook' },
	{ label: 'Google PPC', value: 'Google PPC' },
	{ label: 'Google Search', value: 'Google Search' },
	{ label: 'Integration Partner', value: 'Integration Partner' },
	{ label: 'LinkedIn', value: 'LinkedIn' },
	{ label: 'Marketing Outreach', value: 'Marketing Outreach' },
	{ label: 'Not Specified', value: 'Not Specified' },
	{ label: 'Other', value: 'Other' },
	{ label: 'Previous Customer', value: 'Previous Customer' },
	{ label: 'Reddit', value: 'Reddit' },
	{ label: 'Social Media', value: 'Social Media' },
	{ label: 'Software Advice', value: 'Software Advice' },
	{ label: 'Tradeshow', value: 'Tradeshow' },
	{ label: 'Trial Signup', value: 'Trial Signup' },
	{ label: 'Webinar', value: 'Webinar' },
	{ label: 'Webinar - External', value: 'Webinar - External' },
	{ label: 'Webinar - Internal', value: 'Webinar - Internal' },
	{ label: 'Website', value: 'Website' },
	{ label: 'Word-of-Mouth/Unknown Referral', value: 'Word-of-Mouth/Unknown Referral' },
];

export const LOST_REASON_OPTIONS: FilterOption[] = [
	{ label: 'Board Rejected', value: 'Board Rejected' },
	{ label: 'Budget', value: 'Budget' },
	{ label: 'Budget Cycle', value: 'Budget Cycle' },
	{ label: 'Captive', value: 'Captive' },
	{ label: 'Competitor', value: 'Competitor' },
	{ label: 'DIY', value: 'DIY' },
	{ label: 'DM Not Selling - Need Agent Buy-In', value: 'DM Not Selling - Need Agent Buy-In' },
	{ label: 'Lack of Structured Contacts', value: 'Lack of Structured Contacts' },
	{ label: 'Lost Contact', value: 'Lost Contact' },
	{ label: 'Low Email Volume', value: 'Low Email Volume' },
	{ label: 'Missing Features', value: 'Missing Features' },
	{ label: 'Not Decision Maker', value: 'Not Decision Maker' },
	{ label: 'Other (See Closed Lost Reason)', value: 'Other (See Closed Lost Reason)' },
	{ label: 'Paper Files', value: 'Paper Files' },
	{ label: 'Qualified Out at Beginning (Qualified Out)', value: 'Qualified Out' },
	{ label: 'Regulations', value: 'Regulations' },
	{ label: 'Retired Or Semi-Retired', value: 'Retired Or Semi-Retired' },
	{ label: 'Technology Overload', value: 'Technology Overload' },
	{ label: 'Timing', value: 'Timing' },
	{ label: 'Understaffed', value: 'Understaffed' },
];

// Industry options from existing enum (sorted alphabetically by display value)
export const INDUSTRY_OPTIONS: FilterOption[] = Object.values(Industry)
	.map(value => ({ label: value, value }))
	.sort((a, b) => a.label.localeCompare(b.label));

export const IS_COLD_DEMO_OPTIONS: FilterOption<boolean>[] = [
	{ label: 'No', value: false },
	{ label: 'Yes', value: true },
];

export const OVERBOOK_OPTIONS: FilterOption<boolean>[] = [
	{ label: 'No', value: false },
	{ label: 'Yes', value: true },
];

export enum CustomerType {
	All = 'all',
	Upgrade = 'upgrade',
	New = 'new',
}

export const CUSTOMER_TYPE_OPTIONS: FilterOption<CustomerType>[] = [
	{ label: 'All', value: CustomerType.All },
	{ label: 'Upgrade', value: CustomerType.Upgrade },
	{ label: 'Non-Upgrade (New)', value: CustomerType.New },
];
